import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Calendar } from "lucide-react";
import { BRAND } from "@/lib/brand";

/*
 * FloatingActions
 * ────────────────
 *  Only a sticky mobile CTA bar (Book Demo + WhatsApp) that appears after the user scrolls
 *  further down. No desktop floating widget — the page relies on in-content CTAs and the
 *  header/hero buttons instead, for a cleaner footer hierarchy.
 */
export const FloatingActions = ({ onBookDemo }) => {
  const [showStickyMobile, setShowStickyMobile] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowStickyMobile(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {showStickyMobile && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          data-testid="sticky-mobile-cta"
          className="fixed bottom-0 inset-x-0 z-[9998] lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur px-3 py-2.5 flex gap-2 shadow-[0_-8px_24px_-12px_rgba(15,23,42,0.18)]"
        >
          <button
            onClick={onBookDemo}
            data-testid="sticky-book-demo"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 text-white text-sm font-semibold h-11"
          >
            <Calendar className="h-4 w-4" /> Book Demo
          </button>
          <a
            href={BRAND.whatsapp.waLink}
            target="_blank"
            rel="noreferrer"
            data-testid="sticky-whatsapp"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 text-white text-sm font-semibold h-11"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
